import AccordionComponent from '../../AccordionComponent';

export default function Accordion ({ items }) {
  return (
    <div className="col-span-full">
      {<AccordionComponent tabs={items} />}
    </div>
  )
}
